import { createContext } from 'react';

import {
  Auth0UserItem,
  IBAuth0RoleSummary,
} from '@totem/components/services/remoteAccess/auth0users/details/types';

interface Context {
  loading: boolean;
  user: Auth0UserItem | null;
  roles: IBAuth0RoleSummary[];
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  user: null,
  roles: [],
  onRefresh: () => {},
});
